module.exports = __webpack_public_path__ + "img/legume-lima-beans-350x184.e0b4252a.jpg";